<template>
    <div>
        <!-- Export Data -->
        <div>
            <button
                class="m-2 p-0 btn-export-table"
                @click="modals.download.show = true"
            >
                <span class="block-icon">
                    <CIcon :content="$options.icons.cilDataTransferDown" />
                </span>
                <span class="text">
                    {{ $t("export_to_csv") }}
                </span>
            </button>
        </div>

        <CContainer>
            <!-- Modal export -->
            <CModal
                :title="$t('download_to_csv')"
                color="primary"
                :show.sync="modals.download.show"
                :closeOnBackdrop="false"
            >
                <CSelect
                    :isValid="optionsIsValid"
                    :value.sync="valueComponent"
                    :options="optionsComponent"
                    :label="'Type Download'"
                    @change="downloadIsValid()"
                    :placeholder="'Select type'"
                />
                <template #footer>
                    <!-- Button download -->
                    <CButton
                        color="success"
                        class="button m-2"
                        :disabled="isDisabled"
                        @click="download()"
                        :title="$t('download')"
                    >
                        <span class="button__icon">
                            <CIcon
                                :content="$options.icons.cilDataTransferDown"
                            />
                        </span>
                        <span class="button__text">
                            {{ $t("export") }}
                        </span>
                    </CButton>
                    <!-- Button back -->
                    <CButton
                        color="primary"
                        class="button m-2"
                        @click="modals.download.show = false"
                        :title="$t('close')"
                    >
                        <span class="button__icon">
                            <CIcon
                                :content="$options.icons.cilArrowThickFromRight"
                            />
                        </span>
                        <span class="button__text">
                            {{ $t("close") }}
                        </span>
                    </CButton>
                </template>
            </CModal>
        </CContainer>
    </div>
</template>

<script>
import { cilDataTransferDown, cilArrowThickFromRight } from "@coreui/icons";
import modalMixin from "~/mixins/modal.js";
import tableMixin from "~/mixins/table.js";
export default {
    name: "ButtonExportComponent",
    icons: {
        cilArrowThickFromRight,
        cilDataTransferDown,
    },
    components: {},
    mixins: [modalMixin, tableMixin],
    data() {
        return {
            tables: {},
            modals: {
                download: {
                    show: false,
                },
            },
            valueComponent: null,
            optionsComponent: [
                { label: "Only table", value: "only_table" },
                { label: "All data", value: "all_data" },
            ],
            optionsIsValid: null,
            isDisabled: null,
        };
    },
    computed: {},
    props: {
        endPoint: {
            default: undefined,
        },
        table: {
            type: Object,
        },
        delimiter: {
            type: String,
            default: ",",
        },
        stringDelimiter: {
            type: String,
            default: "'",
        },
        adapterFilters: {
            type: Function,
        },
        /**
         * Params sueltos para el endpoint de export, fuera del `query` (por
         * ejemplo `stats_from`/`stats_to`). Sin esto el CSV saldria con una
         * ventana de fechas distinta a la que muestra la tabla.
         */
        queryParams: {
            type: Object,
            default: undefined,
        },
        baseURL: {
            default: undefined,
        },
    },

    watch: {
        table(newValue) {
            this.tables = {
                default: newValue,
            };
        },
    },

    methods: {
        downloadIsValid() {
            if (!this.valueComponent) {
                this.optionsIsValid = false;
            } else {
                this.optionsIsValid = true;
            }
        },
        async download() {
            this.isDisabled = true;
            if (!this.valueComponent) {
                this.optionsIsValid = false;
            } else if (this.valueComponent == "only_table") {
                this.downloadExportTable({
                    tableName: "",
                    fileName: "export",
                });
            } else if (this.valueComponent == "all_data") {
                await this.downloadAllData();
            }
            this.isDisabled = false;
            this.modals.download.show = false;
        },
        async downloadAllData() {
            var tableName = this.getTableName();
            this.tables[tableName].loading = true;

            // Function adapter filter by default
            let adapterFiltersFunction = (filters) => {
                delete filters.where.countryName;
                return filters;
            };

            if (
                this.adapterFilters &&
                this.adapterFilters instanceof Function
            ) {
                adapterFiltersFunction = this.adapterFilters;
            }

            await this.downloadAllTable({
                tableName: "",
                url: this.endPoint,
                delimiter: this.delimiter,
                stringDelimiter: this.stringDelimiter,
                adapterFilters: adapterFiltersFunction,
                baseURL: this.baseURL,
                queryParams: this.queryParams,
            });
            this.tables[tableName].loading = false;
        },
    },
    mounted() {
        this.tables = {
            default: this.table,
        };
    },
};
</script>

<style lang="scss" scoped></style>
